module.exports = __webpack_public_path__ + "static/media/bullhorn-outline.6146c72e.svg";